(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('givenLoyaltyPerDayReportController', givenLoyaltyPerDayReportController);

  /** @ngInject */
  function givenLoyaltyPerDayReportController ($scope, $translate, reportExportUtil, exportToCsv, GivenLoyaltyPerDayReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new GivenLoyaltyPerDayReportViewModel();
    vm.exportToCsv = exportCsv;
    vm.namingData = 'TOKENS_TITLE';

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('TOTAL_SPENT_LOCAL_TOKENS_PER_DAY'),
          true);
    }

  }
})();
